// Workflow Client Type Constants
// Centralized constants for workflow client types to avoid hardcoding values across the application

export const WORKFLOW_CLIENT_TYPES = {
  GOVERNANCE: "WORKFLOW_CLIENT_TYPE_GOVERNANCE",
  SUBSCRIPTIONS: "WORKFLOW_CLIENT_TYPE_SUBSCRIPTIONS",
  TRAINING: "WORKFLOW_CLIENT_TYPE_TRAINING",
  GOVERNANCE_CLOUD: "WORKFLOW_CLIENT_TYPE_GOVERNANCE_CLOUD",
} as const;

export const WORKFLOW_CLIENT_TYPE_DISPLAY_MAPPING = {
  [WORKFLOW_CLIENT_TYPES.GOVERNANCE]: "Governance",
  [WORKFLOW_CLIENT_TYPES.SUBSCRIPTIONS]: "Subscriptions",
  [WORKFLOW_CLIENT_TYPES.TRAINING]: "Training",
  [WORKFLOW_CLIENT_TYPES.GOVERNANCE_CLOUD]: "Governance Cloud",
} as const;

// Array of client types for UI components (maintains order)
export const WORKFLOW_CLIENT_TYPE_OPTIONS = [
  {
    value: WORKFLOW_CLIENT_TYPES.GOVERNANCE,
    label:
      WORKFLOW_CLIENT_TYPE_DISPLAY_MAPPING[WORKFLOW_CLIENT_TYPES.GOVERNANCE],
  },
  {
    value: WORKFLOW_CLIENT_TYPES.SUBSCRIPTIONS,
    label:
      WORKFLOW_CLIENT_TYPE_DISPLAY_MAPPING[WORKFLOW_CLIENT_TYPES.SUBSCRIPTIONS],
  },
  {
    value: WORKFLOW_CLIENT_TYPES.TRAINING,
    label: WORKFLOW_CLIENT_TYPE_DISPLAY_MAPPING[WORKFLOW_CLIENT_TYPES.TRAINING],
  },
  {
    value: WORKFLOW_CLIENT_TYPES.GOVERNANCE_CLOUD,
    label:
      WORKFLOW_CLIENT_TYPE_DISPLAY_MAPPING[
        WORKFLOW_CLIENT_TYPES.GOVERNANCE_CLOUD
      ],
  },
] as const;

// Type definitions for better type safety
export type WorkflowClientType =
  typeof WORKFLOW_CLIENT_TYPES[keyof typeof WORKFLOW_CLIENT_TYPES];
